import React, {useState} from "react";
import PropTypes from "prop-types";
import {checkNull, checkNullArr, getArrLen} from "../utils/ReactUtils";

function SliderCarousel({
                            slides = [],
                            showIndicators = true,
                            showControls = true,
                            height = 400,
                            onChange,
                            transitionEffect = 'slide',//flip
                            className = "",
                            style = {},
                        }) {
    const TAG = "SliderCarousel";

    const [activeSlide, setActiveSlide] = useState(0);

    const handleChange = (index) => {
        if (index < 0) {
            setActiveSlide(getArrLen(slides) - 1);
        } else if (index >= getArrLen(slides)) {
            setActiveSlide(0);
        } else {
            setActiveSlide(index);
        }
        if (checkNull(onChange)) onChange(index);
    };

    return (
        <div
            className={`${className} risen-sm`}
            style={{display: "flex", justifyContent: "center", ...style}}
        >
            <div
                id="carouselExampleIndicators"
                className={`carousel slide ${transitionEffect}`}
                data-ride="carousel"
                style={{height: height, width: "100%"}}
            >
                {showIndicators && slides.length > 0 && (
                    <ol className="carousel-indicators">
                        {checkNullArr(slides) &&
                            slides.map((slide, index) => (
                                <li
                                    key={index}
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to={index}
                                    className={index === activeSlide ? "active" : ""}
                                    onClick={() => handleChange(index)}
                                ></li>
                            ))}
                    </ol>
                )}
                <div className="carousel-inner">
                    {checkNullArr(slides) &&
                        slides.map((slide, index) => (
                            <div
                                key={index}
                                className={`carousel-item ${
                                    index === activeSlide ? "active" : ""
                                }`}
                            >
                                <img
                                    className="d-block w-100"
                                    src={slide}
                                    alt={`Slide ${index + 1}`}
                                />
                                {/*<div className="carousel-caption">*/}
                                {/*    {checkNullStr(slide.title) && <h3>{slide.title}</h3>}*/}
                                {/*    {checkNullStr(slide.subtitle) && <p>{slide.subtitle}</p>}*/}
                                {/*</div>*/}
                            </div>
                        ))}
                </div>
                {showControls && (
                    <a
                        className="carousel-control-prev"
                        href="common/fusion-ui/view/SliderCarousel#carouselExampleIndicators"
                        role="button"
                        data-slide="prev"
                        onClick={() => handleChange(activeSlide - 1)}
                    >
            <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
            ></span>
                        <span className="sr-only">Previous</span>
                    </a>
                )}
                {showControls && (
                    <a
                        className="carousel-control-next"
                        href="common/fusion-ui/view/SliderCarousel#carouselExampleIndicators"
                        role="button"
                        data-slide="next"
                        onClick={() => handleChange(activeSlide + 1)}
                    >
            <span
                className="carousel-control-next-icon"
                aria-hidden="true"
            ></span>
                        <span className="sr-only">Next</span>
                    </a>
                )}
            </div>
        </div>
    );
}

SliderCarousel.propTypes = {
    slides: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            title: PropTypes.string,
            subtitle: PropTypes.string,
        })
    ).isRequired,
    activeSlide: PropTypes.number,
    slideSize: PropTypes.number,
    showIndicators: PropTypes.bool,
    showPreviousButton: PropTypes.bool,
    showControls: PropTypes.bool,
    height: PropTypes.number,
    onChange: PropTypes.func,
    transitionEffect: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
};
export default SliderCarousel;
